<template>
  <div>
    <!-- <v-row>
      <v-col cols="12" md="3" xs="12">
      </v-col>
      <v-col cols="12" md="3" xs="12">
      </v-col>
      <v-col cols="12" md="3" xs="12">
      </v-col>
      <v-col cols="12" md="3" xs="12">
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" xs="12">
      </v-col>
      <v-col cols="12" md="6" xs="12">
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" xs="12">
      </v-col>
    </v-row> -->

    <v-card>
      <v-card-text class="d-flex align-center justify-center">
        <div>
          <SHeader icon="fa-screwdriver-wrench">
            <template v-slot:title>En mode maintenance !</template>
          </SHeader>
          <div class="ma-2 text-overline">
            L'application est en cours de développement d'autres fonctionnalités
            !
          </div>
        </div>
        <v-img
          :src="require('@/assets/icons/under-maintenance.gif')"
          max-width="350"
        ></v-img>
      </v-card-text>
    </v-card>

    <SAlert
      v-model="alert"
      :message="message"
      :success="successAlert"
      :error="!successAlert"
      :action-type="actionType"
      @onClose="alert = false"
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Home",
  data: () => ({
    alert: false,
    successAlert: false,
    message: "",
    actionType: "normal",
    ticker: Date.now(),
    created: Date.now(),
    timestamp: "",
  }),
  methods: {
    openAlert({ success, message }) {
      this.alert = true;
      this.successAlert = success;
      this.message = message;
    },
    ...mapActions({}),
  },
  computed: {
    revenueStat() {},
    ...mapGetters({}),
  },
  watch: {
    // ticker() {
    //   moment.locale("fr");
    //   let zone = moment().utcOffset();
    //   let time = moment.utc(this.created).utcOffset(zone);
    //   this.timestamp = "" + time.fromNow();
    // },
  },
  async created() {},
};
</script>

<style></style>
